<template>
  <div>
    <CModal
      v-show="onboardFromCBAModal"
      @close="closeCbaModal"
      footer
      modalIsLarge
    >
      <template v-slot:title>
        <h5>Onboad CBA Customers</h5>
      </template>
      <template v-slot:body>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="title">Account Number</label>
              <input
                type="text"
                class="form-control"
                name="title"
                v-model="account_number"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="title">BVN</label>
              <input
                type="text"
                class="form-control"
                name="title"
                v-model="bvn"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="title">Email</label>
              <input
                type="text"
                class="form-control"
                name="title"
                v-model="email"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="title">&nbsp;</label>
              <button
                @click.prevent="onboardStepOne"
                :disabled="onboard_cba_loading"
                class="btn btn-primary form-control"
              >
                <span class="custom-loader" v-if="onboard_cba_loading">
                  <loader-icon size="1.5x" class="custom-class"></loader-icon>
                  <span style="font-weight: 600; text-transform: initial;"
                    >Fetching Account Details...</span
                  >
                </span>
                <span v-else>
                  Get Account Details
                </span>
              </button>
            </div>
          </div>
        </div>
        <div class="row" v-if="account_details">
          <div class="col-md-12">
            <div class="form-group">
              <label for="title">Account Name</label>
              <input
                type="text"
                class="form-control"
                name="title"
                readonly
                v-model="account_details.account_name"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="title">First Name</label>
              <input
                type="text"
                class="form-control"
                name="title"
                readonly
                v-model="account_details.first_name"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="title">Last Name</label>
              <input
                type="text"
                class="form-control"
                name="title"
                readonly
                v-model="account_details.last_name"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="title">BVN</label>
              <input
                type="text"
                class="form-control"
                name="title"
                readonly
                v-model="account_details.bvn"
              />
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <label for="title">Address</label>
              <input
                type="text"
                class="form-control"
                name="title"
                v-model="account_details.address"
                readonly
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="title">Email</label>
              <input
                type="text"
                class="form-control"
                name="title"
                v-model="account_details.email"
                readonly
              />
            </div>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <button
          class="btn btn-success text-white"
          @click.prevent="createCbaCustomer"
          v-if="account_details"
          :disabled="onboard_cba_loading"
        >
          <span class="custom-loader" v-if="onboard_cba_loading">
            <loader-icon size="1.5x" class="custom-class"></loader-icon>
            <span style="font-weight: 600; text-transform: initial;"
              >Creating Application...</span
            >
          </span>
          <span v-else>
            Start Application
          </span>
        </button>
        <button @click.prevent="closeCbaModal" class="btn btn-secondary">
          Cancel
        </button>
      </template>
    </CModal>
    <modal
      v-show="createCbaAccountModal"
      @close="closeCbaAccountModal = false"
      footer
      modalIsLarge
    >
      <template v-slot:title>
        <h5>Check Customer Details ON CBA</h5>
      </template>
      <template v-slot:body>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="title">CBA Account Number</label>
              <input
                type="text"
                class="form-control"
                name="title"
                v-model="cba_account_number"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="title">&nbsp;</label>
              <button
                @click.prevent="getCustomerAccount"
                :disabled="get_cba_account_detail_loading"
                class="btn btn-primary form-control"
              >
                <span
                  class="custom-loader"
                  v-if="get_cba_account_detail_loading"
                >
                  <loader-icon size="1.5x" class="custom-class"></loader-icon>
                  <span style="font-weight: 600; text-transform: initial;"
                    >Fetching Account Details...</span
                  >
                </span>
                <span v-else>
                  Get  Account Details
                </span>
              </button>
            </div>
          </div>
        </div>
        <div class="row" v-if="cba_account_details">
          <div class="col-md-6">
            <KeyValue
              objKey="First Name"
              :objValue="cba_account_details.OtherNames"
            />
          </div>
          <div class="col-md-6">
            <KeyValue
              objKey="Last Name"
              :objValue="cba_account_details.LastName"
            />
          </div>
          <div class="col-md-6">
            <KeyValue objKey="Adress" :objValue="cba_account_details.Address" />
          </div>
          <div class="col-md-6">
            <KeyValue objKey="Landmark" :objValue="cba_account_details.Landmark" />
          </div>
          <div class="col-md-6">
            <KeyValue
              objKey="BVN"
              :objValue="cba_account_details.BankVerificationNumber"
            />
          </div>
          <div class="col-md-6">
            <KeyValue
              objKey="Phone Number"
              :objValue="cba_account_details.PhoneNumber"
            />
          </div>
          <div class="col-md-6">
            <KeyValue
              objKey="Date of Birth"
              :objValue="cba_account_details.DateOfBirth"
            />
          </div>          
        </div>
      </template>
      <template v-slot:footer>
        <button @click.prevent="closeCbaCreateModal" class="btn btn-secondary">
          Cancel
        </button>
      </template>
    </modal>
    <KiddiesOnboardingModal
      :visible="kiddiesOnboardingModal"
      @close="kiddiesOnboardingModal = false"
      @success="onKiddiesOnboardingSuccess"
    />
    <div
      v-if="pageLoading"
      style="display: flex; top: 0px; position: fixed; left: 0px; right: 0px; bottom: 0px; background-color: rgba(247, 247, 247, 0.9); z-index: 9999; justify-content: center; align-items: center;"
    >
      <div>
        <div>
          <h3>{{loader_message}}</h3>
        </div>
      </div>
    </div>
    <div>
      <div class="row align-items-center justify-content-between mb-2">
        <div class="col">
          <h1 class="mb-2 font-regular">Customers</h1>
        </div>
      </div>

      <div class="row" v-if="customerStats !== null">
        <div class="col-xl-3 col-lg-6 col-6 px--5">
          <CCard
            :bgColor="'#7987A1'"
            :text="'All Customers'"
            :currency="false"
            :value="customerStats.all_customers"
            :cardImg="usersIcon"
          />
        </div>
        <div class="col-xl-3 col-lg-6 col-6 px--5">
          <CCard
            :bgColor="'#FBC108'"
            :text="'All Time Customers'"
            :currency="false"
            :value="customerStats.all_time_customers"
            :cardImg="usersIcon"
          />
        </div>
        <div class="col-xl-3 col-lg-6 col-6 px--5">
          <CCard
            :bgColor="'#2CB858'"
            :text="'New Customers This Month'"
            :currency="false"
            :value="customerStats.new_customers_this_month"
            :cardImg="usersIcon"
          />
        </div>
        <div class="col-xl-3 col-lg-6 col-6 px--5">
          <CCard
            :bgColor="'#2CB858'"
            :text="'New Customers This week'"
            :currency="false"
            :value="customerStats.new_customers_this_week"
            :cardImg="usersIcon"
          />
        </div>
        <div class="col-xl-3 col-lg-6 col-6 px--5">
          <CCard
            :bgColor="'#FBC108'"
            :text="'New Customers Today'"
            :currency="false"
            :value="customerStats.new_customers_today"
            :cardImg="usersIcon"
          />
        </div>
        <div class="col-xl-3 col-lg-6 col-6 px--5">
          <CCard
            :bgColor="'#7987A1'"
            :text="'Pending Identity Verification'"
            :currency="false"
            :value="customerStats.pending_id_verification"
            :cardImg="usersIcon"
          />
        </div>
        <div class="col-xl-3 col-lg-6 col-6 px--5">
          <CCard
            :bgColor="'#FBC108'"
            :text="'Pending Utility Bill Verification'"
            :currency="false"
            :value="customerStats.pending_utility_bill_verification"
            :cardImg="usersIcon"
          />
        </div>
        <div class="col-xl-3 col-lg-6 col-6 px--5">
          <CCard
            :bgColor="'#FBC108'"
            :text="'AL RW BL'"
            :currency="false"
            :value="customerStats.all_rewards_balance"
            :cardImg="usersIcon"
          />
        </div>
      </div>

      <div class="row align-items-end my-4">
        <div class="col-xl-2 col-lg-6 col-12 px--5">
          <div class="form-group">
            <label>Account No</label>
            <input
              type="text"
              class="form-control"
              v-model="account_number"
              placeholder="Search By Account Number"
            />
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label for="user_state">States</label>
            <select
              name="state"
              id="state"
              v-model="state_id"
              class="form-control"
            >
              <option value=""></option>
              <option
                :value="state.id"
                v-for="state in states"
                :key="state.id"
                >{{ state.name }}</option
              >
            </select>
          </div>
        </div>
        <div class="col-xl-2 col-lg-6 col-12 px--5">
          <div class="form-group">
            <label for="">Username</label>
            <input
              type="text"
              class="form-control"
              v-model="username_query"
              placeholder="Search by Username"
            />
          </div>
        </div>
        <div class="col-xl-2 col-lg-6 col-12 px--5">
          <div class="form-group">
            <label>Name</label>
            <input
              type="text"
              class="form-control"
              v-model="name"
              placeholder="Search By Fullname"
            />
          </div>
        </div>
        <div class="col-xl-2 col-lg-6 col-12 px--5">
          <div class="form-group">
            <label>Email</label>
            <input
              type="text"
              class="form-control"
              v-model="email"
              placeholder="Search By Email"
            />
          </div>
        </div>
        <div class="col-xl-2 col-lg-6 col-12 px--5">
          <div class="form-group">
            <label>Phone Number</label>
            <input
              type="text"
              class="form-control"
              v-model="phone_number"
              placeholder="Search By Phone Number"
            />
          </div>
        </div>
        <div class="col-xl-2 col-lg-6 col-12 px--5">
          <div class="form-group">
            <label>Customer Status Type</label>
            <select class="form-control" v-model="status">
              <option value selected disabled>Status</option>
              <option value="">All</option>
              <option value="pending_kyc">Pending KYC</option>
              <option value="pending_profile_status"
                >Pending Profile Status</option
              >
              <option value="active_profile_status"
                >Active Profile Status</option
              >
              <option value="ai_treated"
                >AI Treated</option
              >
              <option value="ai_treated_both"
                >AI Treated Both</option
              >
            </select>
          </div>
        </div>
        <div class="col-xl-3 col-lg-6 col-12 px--5">
          <div class="form-group">
            <button @click.prevent="getCustomers(1)" class="button btn">
              <span class="custom-loader" v-if="loading">
                <loader-icon size="1.5x" class="custom-class"></loader-icon>
                <span style="font-weight: 600; text-transform: initial;"
                  >Please Wait</span
                >
              </span>
              <span v-else>Submit</span>
            </button>
          </div>
        </div>
      </div>
      <div class="card card--no-shadow">
        <div class="card-header">
          <div class=" row justify-content-between">
            <div class="col-auto">
              <slot name="header">
                <h4 class="card-title">Customers Tab</h4>
              </slot>
            </div>
            <div class="col-auto">
              <button class="btn btn-primary" @click="showCbaModal">
                Onboard From CBA
              </button>              
              <button class="btn btn-primary" @click="showCreateCbaAccountModal">
                Check Customer Details On CBA
              </button>
              <button
                v-if="permissions.includes('open-kiddies-account')"
                class="btn btn-primary"
                @click="showKiddiesOnboardingModal"
              >
                Open Kiddies Account
              </button>
              <router-link
                v-if="permissions.includes('account-requests')"
                class="button"
                to="/customers/account-requests"
              >
                Account Requests
              </router-link>            
            </div>
          </div>

          <div v-if="customers.length > 0">
            <p class=" d-none">
              <span v-for="i of customers" :key="i.id">
                <span
                  v-for="(a, index) of i.accounts"
                  :key="index"
                  class="fw-bold"
                >
                  {{ a.account_number }} {{ "," }}
                </span>
              </span>
            </p>
          </div>
        </div>
        <div class="card-content">
          <div class="card-body">
            <CDataTable :items="customers" :fields="fields" sorter>
              <template #account_number="{item}">
                <td>
                  <div v-for="(i, index) of item.accounts" :key="index">
                    <p class="fw-bold">{{ i.account_number }}</p>
                  </div>
                </td>
              </template>
              <template #id="{item}">
                <td class="table--action-mobile">
                  {{ item.id }}
                  <div v-if="item.onboarding_source === 'manual'">
                    <span class="badge badge-info">Manual</span>
                  </div>
                  <div v-if="item.kyc">
                    <span class="badge" v-if="item.kyc.id_ai_status"
                      :class="{
                        'badge-success': item.kyc.id_ai_status == 'success',
                        'badge-danger': item.kyc.id_ai_status == 'failed'
                      }"
                      >
                        AID - {{ item.kyc.id_ai_status }} {{ item.kyc.id_ai_status  === 'success'  ? '✅' : '❌' }}
                    </span>
                    <span class="badge" v-if="item.kyc.bill_ai_status"
                      :class="{
                        'badge-warning': item.kyc.bill_ai_status == 'success',
                        'badge-danger': item.kyc.bill_ai_status == 'failed'
                      }"
                      >
                        AIBILL - {{ item.kyc.bill_ai_status }} {{ item.kyc.bill_ai_status  === 'success'  ? '✅' : '❌' }}
                    </span>
                  </div>
                </td>
              </template>
              <template #onboarding_source="{item}">
                <td>
                  <span
                    v-if="item.onboarding_source === 'manual'"
                    class="badge badge-info"
                  >
                    Manual
                  </span>
                  <span v-else class="text-muted">-</span>
                </td>
              </template>
              <template #created_at="{item}">
                <td class="table--action-mobile">
                  {{ item.created_at | date }}
                </td>
              </template>
              <template #id_status="{item}">
                <td>{{ item.kyc.identity_status }}</td>
              </template>
              <template #utility_status="{item}">
                <td>{{ item.kyc.utility_bill_status }}</td>
              </template>
              <template #action="{item}">
                <td class="table--action-mobile">
                  <router-link
                    v-if="permissions.includes('view-customer')"
                    :event="
                      permissions.includes('view-customer') ? 'click' : ''
                    "
                    class="button"
                    :class="
                      permissions.includes('view-customer')
                        ? ''
                        : 'disabled cursor-not-allowed'
                    "
                    :to="{
                      name: 'CustomerComponent',
                      params: { slug: item.id }
                    }"
                  >
                    View
                  </router-link>
                </td>
              </template>
            </CDataTable>
            <CPagination
              :activePage.sync="next_page"
              :pages="total"
              :onActivePageChange="onPageChange()"
            ></CPagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CDataTable from "@/components/CDataTable.vue";
import ApiService from "@/services/api.service";
import CPagination from "@/components/CPagination";
import usersIcon from "@/assets/images/users-avatar.png";
import CModal from "../../components/CModal.vue";
import CCard from "../../components/CCard.vue";
import ErrorService from "@/services/error.service";
import KeyValue from "@/components/KeyValue.vue";
import KiddiesOnboardingModal from "@/components/customers/KiddiesOnboardingModal.vue";

import Swal from "sweetalert2";

const fields = [
  "id",
  "account_number",
  "username",
  "first_name",
  "last_name",
  "other_name",
  "phone_number",
  "email",
  "onboarding_source",
  "date",
  "id_status",
  "utility_status",
  "profile_status",
  "reward_balance",
  "action"
];
export default {
  name: "Customers",
  components: {
    CDataTable,
    CPagination,
    CCard,
    CModal,
    KeyValue,
    KiddiesOnboardingModal
  },
  data() {
    return {
      small: true,
      fields,
      customers: [],
      customerStats: null,
      next_page: 1,
      total: 1,
      current: 1,
      usersIcon,
      start_date: "",
      stop_date: "",
      search: "",
      pageLoading: false,
      name: "",
      email: "",
      phone_number: "",
      account_number: "",
      bvn: "",
      loading: false,
      status: "",
      username_query: "",
      onboardFromCBAModal: false,
      onboard_cba_loading: false,
      account_details: null,
      createCbaAccountModal : false,
      cba_account_number: "",
      get_cba_account_detail_loading: false,
      cba_account_details: null,
      loader_message: "Loading Customers...",
      states : [],
      state_id : '',
      kiddiesOnboardingModal: false
    };
  },
  computed: {
    permissions() {
      let permissions = this.$store.getters.permissions;
      return permissions;
    }
  },
  methods: {
    async getCustomers(page) {
      console.log("Customer Endpoint");
      this.loader_message = "Loading Customers...";
      try {
        this.pageLoading = true;
        const response = await ApiService.get(
          `customer/all-customers?page=${page}&name=${this.name}&username=${this.username_query}&email=${this.email}&phone_number=${this.phone_number}&account_number=${this.account_number}&status=${this.status}&state_id=${this.state_id}`
        );
        console.log(response.data.data);
        this.customers = response.data.data.data;
        this.current = response.data.data.current_page;
        this.total = response.data.data.last_page;
        this.pageLoading = false;
      } catch (error) {
        console.log(error.response);
        this.pageLoading = false;
      }
    },
    onPageChange() {
      console.log(this.next_page);
      if (this.current != this.next_page) {
        this.getCustomers(this.next_page);
      }
    },
    async getCustomerAccount() {
      this.pageLoading = true;
      this.loader_message = 'Getting Account Details....'
      try {        
        const response = await ApiService.post(`account/get_customer_details`,{
          account_number : this.cba_account_number
        });
        console.log(response.data.data);
        this.loader_message = '';
        this.pageLoading = false;
        this.cba_account_details = response.data.data;
      } catch (error) {
        console.log(error);
        this.pageLoading = false;
        let _error = error.response.data;
        ErrorService.displayErrorAlert(_error);
      }
    },
    async getCustomerStats() {
      try {
        const response = await ApiService.get(`stats/customers`);
        this.customerStats = response.data.data;
      } catch (error) {
        console.log(error);
      }
    },
    showCbaModal() {
      this.onboardFromCBAModal = true;
    },
    closeCbaModal() {
      this.onboardFromCBAModal = false;
    },
    showCreateCbaAccountModal() {
      this.createCbaAccountModal = true;
    },
    closeCbaCreateModal() {
      this.createCbaAccountModal = false;
    },
    showKiddiesOnboardingModal() {
      this.kiddiesOnboardingModal = true;
    },
    onKiddiesOnboardingSuccess() {
      this.getCustomers(this.current);
      this.getCustomerStats();
    },
    async onboardStepOne() {
      this.onboard_cba_loading = true;
      try {
        const response = await ApiService.post(
          `customer/initiate_create_account_from_cba`,
          {
            account_number: this.account_number,
            bvn: this.bvn,
            email: this.email
          }
        );
        console.log(response.data);
        this.account_details = response.data.data;
        this.onboard_cba_loading = false;
      } catch (error) {
        this.onboard_cba_loading = false;
        console.log(error.response);
        ErrorService.displayErrorAlert(error.response.data);
      }
    },
    async createCbaCustomer() {
      this.onboardFromCBAModal = false;
      //swal confirmation
      const swalResponse = await Swal.fire({
        title: `<div>
                    <p >Confirm the following Details</p>
                    <p class='m-0 confirm_font'>Account Name: <span>${this.account_details.account_name}</span></p>
                    <p class='m-0 confirm_font'>First Name: <span>${this.account_details.first_name}</span></p>
                    <p class='m-0 confirm_font'>Last Name: <span>${this.account_details.last_name}</span></p>
                    <p class='m-0 confirm_font'>Address: <span>${this.account_details.address}</span></p>
                    <p class='m-0 confirm_font'>Email: <span>${this.account_details.email}</span></p>
                    <p class='m-0 confirm_font'>Phone Number: <span>${this.account_details.phone_number}</span></p>
                    </div>`,
        text: "You are about to create a customer on mobile banking",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, create it!"
      });

      if (!swalResponse.isConfirmed) {
        return;
      }

      // close modal     

      try {
        this.onboard_cba_loading = true;
        this.pageLoading = true;
        this.loader_message = "Creating Customer...";
        const response = await ApiService.post(
          "customer/finalize_create_account_from_cba",
          {
            account_number: this.account_details.account_number,
            bvn: this.account_details.bvn,
            email: this.account_details.email
          }
        );
        console.log(response);
        this.onboard_cba_loading = false;
        this.pageLoading = false;
        this.account_details = null;

        //success
        Swal.fire({
          title: "Success",
          text: "Customer created successfully",
          icon: "success",
          confirmButtonColor: "#3085d6"
        });

        this.onboardFromCBAModal = false;
        //reload page in 2 seconds
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      } catch (error) {
        this.onboard_cba_loading = false;
        this.pageLoading = false;
        console.log(error.response);
        ErrorService.displayErrorAlert(error.response.data);
      }
    },
    async getStates() {
      try {
        const response = await ApiService.get("utility/state-list");
        this.states = response.data.data;
      } catch (error) {
        console.log(error.response);
      }
    },
  },
  mounted() {
    this.getCustomers(1);
    if (this.can("dashboard")) {
      this.getCustomerStats();
    }
    this.getStates();
  }
};
</script>

<style scoped></style>
